const pathUrl = {
    baseUrl:"https://melo.idrblab.cn/api",
    // baseUrl:"http://127.0.0.1:8015/api",
    localUrl:"https://melo.idrblab.cn",
}

export default pathUrl;